import { usePendingApprovalsCount } from './api';

/** Count next to "Approvals" in the Modules menu and the phone nav sheet. */
export function ApprovalsBadge() {
  const count = usePendingApprovalsCount();
  if (count === 0) return null;
  return (
    <span
      className="ml-auto rounded-full bg-primary px-1.5 text-caption tabular text-primary-foreground"
      aria-label={`${String(count)} waiting`}
    >
      {count > 99 ? '99+' : count}
    </span>
  );
}
